module.exports = __webpack_public_path__ + "static/media/recordista_p.b9098e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/recordista_p.png
// module id = 1173
// module chunks = 0